module.exports = {"131181100":"冀州镇","131181102":"官道李镇","131181103":"南午村镇","131181104":"周村镇","131181105":"码头李镇","131181106":"西王镇","131181200":"门家庄乡","131181201":"徐家庄乡","131181202":"北漳淮乡","131181203":"小寨乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/131181.json
// module id = 255
// module chunks = 0